export default "__VITE_ASSET__Buod$WtD__ 640w, __VITE_ASSET__CRCiUI38__ 1024w";